const types = {
  //Get Template name
  GET_WORK_ORDER_START: "GET_WORK_ORDER_START",
  GET_WORK_ORDER_SUCCESS: "GET_WORK_ORDER_SUCCESS",
  GET_WORK_ORDER_ERROR: "GET_WORK_ORDER_ERROR",
  GET_WORK_ORDER_RESET: "GET_WORK_ORDER_RESET",

  //Create Template name
  CREATE_WORK_ORDER_START: "CREATE_WORK_ORDER_START",
  CREATE_WORK_ORDER_SUCCESS: "CREATE_WORK_ORDER_SUCCESS",
  CREATE_WORK_ORDER_ERROR: "CREATE_WORK_ORDER_ERROR",
  CREATE_WORK_ORDER_RESET: "CREATE_WORK_ORDER_RESET",

  //delete Template name
  DELETE_WORK_ORDER_START: "DELETE_WORK_ORDER_START",
  DELETE_WORK_ORDER_SUCCESS: "DELETE_WORK_ORDER_SUCCESS",
  DELETE_WORK_ORDER_ERROR: "DELETE_WORK_ORDER_ERROR",
  DELETE_WORK_ORDER_RESET: "DELETE_WORK_ORDER_RESET",

  //update Template name
  UPDATE_WORK_ORDER_START: "UPDATE_WORK_ORDER_START",
  UPDATE_WORK_ORDER_SUCCESS: "UPDATE_WORK_ORDER_SUCCESS",
  UPDATE_WORK_ORDER_ERROR: "UPDATE_WORK_ORDER_ERROR",
  UPDATE_WORK_ORDER_RESET: "UPDATE_WORK_ORDER_RESET",

  //single item  name
  SINGLE_WORK_ORDER_START: "SINGLE_WORK_ORDER_START",
  SINGLE_WORK_ORDER_SUCCESS: "SINGLE_WORK_ORDER_SUCCESS",
  SINGLE_WORK_ORDER_ERROR: "SINGLE_WORK_ORDER_ERROR",
  SINGLE_WORK_ORDER_RESET: "SINGLE_WORK_ORDER_RESET",
};

export default types;
